import angular from 'angular';
import contactEmploymentTable from './contactEmploymentTable';

export default angular
  .module('components.contactEmploymentTable', [])
  .component('contactEmploymentTable', contactEmploymentTable).name;
